import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setVehicleUSNG } from '../store/tripInformation.actions'
import { LLtoUSNGwrapper } from '../../../utilities'
import { TripInformationConstants } from '../store/tripInformation.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'

export function* setCalculateVehicleUSNG(pcrDoc: IPcr) {
  try {
    const tripInformation = pcrDoc.patient?.tripInformation
    if (tripInformation && Object.keys(tripInformation).length !== 0) {
      const gpsn_pattern = new RegExp('^((\\+|-)?(90(\\.[0]{1,6})?|([1-8][0-9]|[0-9])(\\.[0-9]{1,6})?))$')
      const gpse_pattern = new RegExp('^((\\+|-)?(180(\\.[0]{1,6})?|(1[0-7][0-9]|[1-9][0-9]|[0-9])(\\.[0-9]{1,6})?))$')
      if (
        tripInformation.vehicleGPSN !== '' &&
        tripInformation.vehicleGPSE !== '' &&
        gpsn_pattern.test(tripInformation.vehicleGPSN) &&
        gpse_pattern.test(tripInformation.vehicleGPSE)
      ) {
        const usng = LLtoUSNGwrapper(
          parseFloat(tripInformation.vehicleGPSN.toString()),
          parseFloat(tripInformation.vehicleGPSE.toString()),
          4
        )
        if (usng) {
          yield put(setVehicleUSNG(usng))
        }
      }
    }
  } catch (e) {
    yield put(throwPcrException(`setCalculateVehicleUSNG() error: ${e}`))
  }
}

export function* preloadPCR() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    yield call(setCalculateVehicleUSNG, pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`preloadPCR() error in setCalculateVehicleUSNG.saga.ts: ${e}`))
  }
}

export function* setCalculateVehicleUSNGSaga() {
  yield takeLatest([TripInformationConstants.CALCULATE_VEHICLE_USNG], performWithMutexHOG, preloadPCR)
}
